<template>
  <tr :class="rowClass" v-if="participation.user">
    <td><input class="form-check-input" type="checkbox" v-model="isChecked" /></td>
    <td v-if="visibleColumns.includes('nom')">
      {{ `${participation.userInfo?.lastName?.toUpperCase() ?? participation.user.lastName?.toUpperCase()} ${participation.userInfo?.firstName ?? participation.user.firstName}`.trim() }}
      <span v-if="companions.length > 0" class="badge bg-secondary ms-1" :title="`${companions.length} accompagnant${companions.length > 1 ? 's' : ''}`">
        <i class="fa-solid fa-user-group me-1"></i>{{ companions.length }}
      </span>
    </td>
    <td v-if="visibleColumns.includes('email')">{{ participation.userInfo?.email ?? participation.user.email }}</td>
    <td v-if="visibleColumns.includes('mobilePhone')">{{ participation.userInfo?.mobilePhone ?? participation.user.mobilePhone }}</td>
    <td v-if="visibleColumns.includes('entreprise')">{{ participation.userInfo?.company ?? participation.user.company }}</td>
    <td v-if="visibleColumns.includes('statut')">
      <ParticipantStatusLinkComponent :participation="participation" />
    </td>
    <td v-if="visibleColumns.includes('signature')">
      <a v-if="participation.signature?.signedDate && participation.signature.signedDocument" target="_blank"
        :href="getFileUrl(participation.signature.signedDocument.key)"
        class=""
        title="Télécharger le document signé">
        <i class="fa-solid fa-pen-nib pe-2 link-underline link-underline-opacity-0"></i>{{ formatDate(participation.signature.signedDate,'DD/MM/YYYY') }}
      </a>
      <span class="text-muted" v-else><i class="fa-regular fa-clock me-1"></i> Non signé</span>
    </td>
    <td class="py-0 text-center">
      <router-link :to="{ name: 'admin-edit-participant', params: { id: participation.user.id } }" class="btn btn-link px-2" title="Modifier le profil du participant">
        <i class="fa-solid fa-user-pen"></i>
      </router-link>
      <a class="btn btn-link px-2" :href="getEditParticipationUrl(participation.user.id)" target="_blank" title="Voir/Modifier l'inscription">
        <i class="fa-regular fa-circle-play"></i>
      </a>
      <a v-if="participation.invitation?.completionDate" target="_blank"
        :href="getAdminWebInscriptionUrl(props.participation.travelDbId, participation.user.id)"
        class="btn btn-link px-2" title="Télécharger l'inscription">
        <i class="fa-solid fa-download"></i>
      </a>
      <button class="btn btn-link px-2" @click="emit('delete', participation.user.id)" title="Supprimer le participant"><i class="fa-regular fa-trash-can"></i></button>
    </td>
  </tr>
  <tr
    v-for="(companion, index) in companions"
    v-show="!props.hideCompanions"
    :key="companion.id ?? index"
    class="companion-row"
  >
    <td><!-- checkbox: non applicable --></td>
    <td v-if="visibleColumns.includes('nom')" class="ps-4 text-muted small">
      <i class="fa-solid fa-user me-1"></i>{{ `${GetCivilityShortLabel(companion.civility)} ${companion.firstName ?? ''} ${companion.lastName?.toUpperCase() ?? ''}`.trim() }}
      <span v-if="companion.relation" class="badge bg-light text-dark border ms-1">{{ GetRelationLabel(companion.relation) }}</span>
    </td>
    <td v-if="visibleColumns.includes('email')" class="text-muted small">{{ companion.email }}</td>
    <td v-if="visibleColumns.includes('mobilePhone')" class="text-muted small">{{ companion.mobilePhone }}</td>
    <td v-if="visibleColumns.includes('entreprise')" class="text-muted small">{{ companion.company }}</td>
    <td v-if="visibleColumns.includes('statut')" class="text-muted small">
      <span class="text-muted">Accompagnant</span>
    </td>
    <td v-if="visibleColumns.includes('signature')"><!-- non applicable --></td>
    <td><!-- actions: non applicable --></td>
  </tr>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { GetCivilityShortLabel, getFileUrl, getAdminWebInscriptionUrl, GetRelationLabel, formatDate } from '@/compositions/helper';

const router = useRouter();

const props = defineProps<{
  participation: ParticipationDb;
  visibleColumns: string[];
  checkedParticipants: number[];
  rowClass?: string;
  hideCompanions?: boolean;
}>();

const emit = defineEmits<{
  'update:checkedParticipants': [ids: number[]];
  'delete': [userId: number];
}>();

const isChecked = computed({
  get: () => props.checkedParticipants.includes(props.participation.user!.id),
  set: (val: boolean) => {
    const userId = props.participation.user!.id;
    if (val) {
      emit('update:checkedParticipants', [...props.checkedParticipants, userId]);
    } else {
      emit('update:checkedParticipants', props.checkedParticipants.filter(id => id !== userId));
    }
  },
});

const companions = computed(() => props.participation.companions ?? []);

const getEditParticipationUrl = (userId: number) => {
  return router.resolve({
    name: 'travel',
    params: { id: props.participation.travelDbId },
    query: { impersonatedUserId: userId },
  }).href;
};
</script>

<style scoped>
.companion-row td {
  border-top: none;
  background-color: rgba(0, 0, 0, 0.02);
}
</style>
